import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ctSmartDropdownContainer]',
})
export class SmartDropdownContainerDirective {
  @HostBinding('class.smart-dropdown-container') public container = true;
  constructor() {}
}
